import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import BodyText from "../../../components/text/body-text/body-text"
import Button from "../../../components/button/button"
import CardsCarousel from "../../../components/cards-carousel/cards-carousel"
import HeaderBanner from "../../../components/HeaderBanner"
import * as styles from "./index.module.css"
import Heading from "../../../components/text/heading/heading"
import { Link, navigate } from "gatsby"
import { NAV_LINKS } from "../../../components/Header/nav-links"
import RegistrationForm from "../../../components/CustomDialogs/RegistrationForm"

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const HomeHeader = ({setSlideIndex}) => {
  const [isRegistrationFormOpen, setIsRegistrationFormOpen] = useState(false)
  const headerData = [
    {
      title: "Get <span>Skilled</span> Get <span>Hired</span>",
      subTitle:
        "Rise to the top of the hiring list with our job-linked training",
      image: (
        <StaticImage
          src="../../../images/index/header/home.png"
          alt="Collage showcasing diverse professionals across industries"
          layout="constrained"
          placeholder="blurred"
          formats={["auto", "webp"]}
          outputPixelDensities={[0.5, 0.75, 1, 2]}
          className={styles.mainImage}
        />
      ),
      buttonText: "Register Now",
      onClick: () => {
        setIsRegistrationFormOpen(true)
      },
      hasSkilledBanner: true,
      testimonial: {
        name: "Manoj Joshi",
        designation: "Manager, ABC Company",
        text: "Learnet’s training gave me the skills to land my dream job",
        image: (
          <StaticImage
            src="../../../images/index/header/testimonial1.png"
            alt="Profile picture of Manoj Joshi, smiling and wearing formal attire"
            className="w-[60px] md:w-[2.85vw]"
            {...commonImageProps}
          />
        ),
      },
    },
    {
      title: "Dream of <span> Working Abroad?</span>",
      subTitle:
        "Our global employment programmes open doors to jobs in countries like Japan & Germany, and regions like the Middle East",
      image: (
        <StaticImage
          src="../../../images/index/header/global.png"
          alt="Collage of diverse professionals working abroad in various industries"
          {...commonImageProps}
          className={styles.mainImage}
        />
      ),
      buttonText: "Know More",
      URL: "/global-career",

      hasSkilledBanner: false,
      iconImage: (
        <StaticImage
          src="../../../images/index/header/dream.png"
          alt="Animated image of dream big "
          className="w-[60px] md:w-[2.85vw]"
          {...commonImageProps}
        />
      ),
      iconText: "<span>10000+ Trained</span><br/> For A Global Career",
      testimonial: {
        name: "Manoj Joshi",
        designation: "Manager, ABC Company",
        text: "Learnet’s training gave me the skills to land my dream job",
        image: (
          <StaticImage
            src="../../../images/index/header/testimonial1.png"
            alt="Profile picture of Manoj Joshi, smiling and wearing formal attire"

            className="w-[60px] md:w-[2.85vw]"
            {...commonImageProps}
          />
        ),
      },
    },
    {
      title: "Start Your  <span> Own Business</span>",
      subTitle:
        "Our entrepreneurship programmes equip you to build and grow your business",
      image: (
        <StaticImage
          src="../../../images/index/header/own-business.png"
          alt="Collage representing entrepreneurship and business ownership"
          className={styles.mainImage}
          {...commonImageProps}
        />
      ),
      buttonText: "Know More",
      URL: "/ed-programme",
      hasSkilledBanner: false,
      iconImage: (
        <StaticImage
          src="../../../images/index/header/business.png"
          alt="Animated image of uplifting your business to the next level"
          className="w-[60px] md:w-[2.85vw]"
          {...commonImageProps}
        />
      ),
      iconText: "<span>10000+ Trained</span><br/> For Entrepreneurship",
      testimonial: {
        name: "Manoj Joshi",
        designation: "Manager, ABC Company",
        text: "Learnet’s training gave me the skills to land my dream job",
        image: (
          <StaticImage
            src="../../../images/index/header/testimonial1.png"
            alt="Profile picture of Manoj Joshi, smiling and wearing formal attire"
            className="w-[60px] md:w-[2.85vw]"
            {...commonImageProps}
          />
        ),
      },
    },
    {
      title: "Graduate <span> To Employed </span>",
      subTitle:
        "Bridge the gap from college to career with <b>Graduate Employment Enhancement Training (GEET)</b>",
      image: (
        <StaticImage
          src="../../../images/index/header/geet-1.png"
          alt="Group picture of graduates in training session"
          className={styles.mainImage}
          {...commonImageProps}
        />
      ),
      buttonText: "Know More",
      URL: "/geet",

      hasSkilledBanner: false,
      iconImage: (
        <StaticImage
          src="../../../images/index/header/icon1.png"
          alt="icon representing the training center"
          className="w-[60px] md:w-[2.85vw]"
          {...commonImageProps}
        />
      ),
      iconText:
        "Partnership With <span> 100+ </span><br/>Colleges & Universities",
      testimonial: {
        name: "Manoj Joshi",
        designation: "Manager, ABC Company",
        text: "Learnet’s training gave me the skills to land my dream job",
        image: (
          <StaticImage
            src="../../../images/index/header/testimonial1.png"
            alt="Profile picture of Manoj Joshi, smiling and wearing formal attire"
            className="w-[60px] md:w-[2.85vw]"
            {...commonImageProps}
          />
        ),
      },
    },
    {
      title: "Drive Change  <span> With CSR Initiatives </span>",
      subTitle:
        "Transform lives with CSR-driven skilling programmes that provide livelihoods and ensures sustainable impact.",
      image: (
        <StaticImage
          src="../../../images/index/header/csr-1.png"
          alt="Group picture representing CSR initiatives and community impact"
          className={styles.mainImage}
          {...commonImageProps}
        />
      ),
      buttonText: "Know More",
      URL: NAV_LINKS.CORPORATE_CHANGEMAKERS,
      hasSkilledBanner: false,
      iconImage: (
        <StaticImage
          src="../../../images/index/header/icon2.png"
          alt="Icon showing corporate office"
          className="w-[60px] md:w-[2.85vw]"
          {...commonImageProps}
        />
      ),
      iconText: "Working With <span> 50+ </span>Corporates",
      testimonial: {
        name: "Manoj Joshi",
        designation: "Manager, ABC Company",
        text: "Learnet’s training gave me the skills to land my dream job",
        image: (
          <StaticImage
            src="../../../images/index/header/testimonial1.png"
            alt="Profile picture of Manoj Joshi, smiling and wearing formal attire"
            className="w-[60px] md:w-[2.85vw]"
            {...commonImageProps}
          />
        ),
      },
    },
  ]
  return (
    <>
      <CardsCarousel
        carouselSettingsOverride={{
          slidesToScroll: 1,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          beforeChange: (currentSlide, nextSlide)=>{
            if(setSlideIndex){
              setSlideIndex(nextSlide);
            }
          }
        }}
      >
        {/* new */}
        {headerData.map(val => {
          return (
            <div key={val.title}>
              <div className="flex gap-8 flex-col md:flex-row">
                <div className="md:w-3/5 pl-0 md:pl-2">
                  <HeadingCover className="mb-2 mt-3">
                    <div dangerouslySetInnerHTML={{ __html: val.title }} />
                  </HeadingCover>
                  <BodyText variant="bodyText6" className="pb-4">
                    <span
                      dangerouslySetInnerHTML={{ __html: `${val.subTitle}` }}
                    />
                  </BodyText>
                  <Button
                    className="mb-4"
                    onClick={() => {
                      if (val.URL) {
                        navigate(val.URL)
                      } else if (val.onClick) {
                        val.onClick()
                      }
                    }}
                  >
                    {val.buttonText}
                  </Button>
                  {val.hasSkilledBanner && (
                    <>
                      <HeadingCover className="mb-0 mt-10">
                        <span>2.7 Million+ </span> Skilled in{" "}
                        <span>15 Years</span>
                      </HeadingCover>
                      <HeaderBanner />
                    </>
                  )}
                  {!val.hasSkilledBanner && (
                    <div className="flex justify-start items-center gap-3 mt-10 mb-2">
                      <div className="border border-[#4559ED] rounded-[50%] p-4 bg-[#E1F2FF] ">
                        {val.iconImage}
                      </div>

                      <Heading variant="h4">
                        <div
                          className={styles.blueText}
                          dangerouslySetInnerHTML={{ __html: val.iconText }}
                        />
                      </Heading>
                    </div>
                  )}
                  {/*  <div className="md:shadow-[0px_2px_10px_#4559ED29] bg-[#fff] py-3 px-4 w-max max-w-full md:max-w-[70%] rounded-lg">
                  <div className="flex gap-3 mb-2">
                    <div>{val.testimonial.image}</div>
                    <div>
                      <BodyText className="font-bold" variant="bodyText6">
                        {val.testimonial.name}
                      </BodyText>
                      <BodyText variant="bodyText8" className="text-[#747474]">
                        {val.testimonial.designation}
                      </BodyText>
                    </div>
                  </div>
                  <div>
                    <BodyText variant="bodyText7">
                      {'"'}
                      {val.testimonial.text}
                      {'"'}
                    </BodyText>
                  </div>
                </div> */}
                </div>
                <div className="md:w-2/5 flex items-center justify-center md:justify-end">
                  {val.image}
                </div>
              </div>
            </div>
          )
        })}
      </CardsCarousel>
      <RegistrationForm
        isOpen={isRegistrationFormOpen}
        setIsOpen={setIsRegistrationFormOpen}
        clickedFrom={"Home-First Banner"}
      />
    </>
  )
}
